import { render, staticRenderFns } from "./TablaTotalSims.vue?vue&type=template&id=8b505d56&"
import script from "./TablaTotalSims.vue?vue&type=script&lang=ts&"
export * from "./TablaTotalSims.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8b505d56', component.options)
    } else {
      api.reload('8b505d56', component.options)
    }
    module.hot.accept("./TablaTotalSims.vue?vue&type=template&id=8b505d56&", function () {
      api.rerender('8b505d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/VerificacionBajaCliente/Editar/TablaTotalSims.vue"
export default component.exports